export function Divider(props: Props) {
  return (
    <div
      style={{
        marginTop: props.top != undefined ? props.top : 16,
        marginBottom: props.bottom != undefined ? props.bottom : 16,
        minHeight: props.size || 1,
        position: "relative",
        width: "100%",
      }}
    >
      <hr
        style={{
          height: props.size || 1,
          backgroundColor: props.color || "#EAECF0",
          opacity: 1,
          position: "absolute",
          left: 0,
          right: 0,
          margin: 0,
          top: "50%",
        }}
      ></hr>
      {props.middleText && (
        <span
          style={{
            display: "inline-block",
            fontWeight: 500,
            fontSize: "14px",
            lineHeight: "20px",
            textAlign: "center",
            backgroundColor: "#FFF",
            padding: "0 8px",
            position: "relative",
            left: "50%",
            transform: "translate(-50%)",
          }}
        >
          {props.middleText}
        </span>
      )}
    </div>
  );
}

interface Props {
  top?: number;
  bottom?: number;
  size?: number;
  color?: string;
  middleText?: string;
}
